import React from "react"
import dropzone from "dropzone"

class FileUploadGroupBuilder extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      file_name: null,
      uploading: false,
      progress: 0,
      file_upload_groups: this.props.file_upload_groups && this.props.file_upload_groups.length ? this.props.file_upload_groups : [],
      remove: typeof this.props.remove !== 'undefined' ? this.props.remove : true,
    }

    this.removeFileUpload = this.removeFileUpload.bind(this);
  }

  // componentWillReceiveProps(nextProps) {
  //   this.setState({file_upload_groups: nextProps.file_upload_groups});
  // }

  componentDidMount() {
    this.initDropzone();
    //this.initSortable();
  }

  componentDidUpdate() {
    this.initDropzone();
    //this.initSortable();
  }

  initDropzone() {
    if (!this.refs['dropzone-input']) {
      return;
    }

    var self = this;
    var $dropzoneInput = $(this.refs['dropzone-input']);

    if ($dropzoneInput.hasClass('dz-clickable')) {
      return;
    }

    $dropzoneInput.dropzone({
      autoProcessQueue: true,
      url: $dropzoneInput.attr('data-url'),
      uploadMultiple: false,
      paramName: 'file_upload[upload]',
      addedfile: function (file) {
        self.setState({ uploading: true, progress: 0, file_name: file.name });
      },
      uploadprogress: function (file, progress) {
        self.setState({ progress: progress });
      },
      success: function (file, response) {
        if (self.state.file_upload_groups && self.state.file_upload_groups.length) {
          var fileUploadGroup = self.state.file_upload_groups[0];
          if (!fileUploadGroup.file_uploads || !fileUploadGroup.file_uploads.length) {
            fileUploadGroup.file_uploads = [];
          }
          fileUploadGroup.file_uploads.unshift(JSON.parse(response.json));
          self.setState({ uploading: false, progress: 100, file_name: null }, () => {
            if (typeof self.props.onChange == 'function') {
              self.props.onChange(fileUploadGroup, self.props.form_field_id ? self.props.form_field_id : null);
            }
          });
        }
      }
    });

    /* dropzone visual cues when dragging */
    $dropzoneInput.on('dragover', function (e) {
      e.preventDefault();
      $(this).addClass('dragover');
    }).on('dragleave drop', function () {
      $(this).removeClass('dragover');
    });

    /* prevent window from loading dropped file that misses the dropzone */
    window.addEventListener("dragover", function (e) {
      e = e || event;
      e.preventDefault();
    }, false);

    window.addEventListener("drop", function (e) {
      e = e || event;
      e.preventDefault();
    }, false);
  }

  // initSortable() {
  //   if (!this.refs.images || this.props.read_only) {
  //     return;
  //   }

  //   var self = this;
  //   var $sortable = $(this.refs.images);

  //   $sortable.sortable({
  //     axis: 'y',
  //     handle: '.handle',
  //     stop: function () {
  //       if (self.state.image_groups && self.state.image_groups.length) {
  //         var imageGroup = self.state.image_groups[0];
  //         var images = [];
  //         var ids = $sortable.sortable('toArray', {attribute: 'data-id'});

  //         $sortable.sortable('cancel'); // prevent sortable from updating the DOM itself

  //         for (var i = 0, ilen = ids.length; i < ilen; i++) {
  //           var image = self.findImage(ids[i]);
  //           image.position = i;
  //           images.push(image);
  //         }

  //         imageGroup.images = images;
  //         self.forceUpdate();
  //         if (typeof self.props.onChange == 'function') {
  //           self.props.onChange(imageGroup);
  //         }
  //         //self.setState({image_group: self.state.image_group});
  //       }
  //     }
  //   });
  // }

  findFileUpload(id) {
    if (this.state.file_upload_groups && this.state.file_upload_groups.length) {
      var fileUploadGroup = this.state.file_upload_groups[0];

      for (var i = 0, ilen = fileUploadGroup.file_uploads.length; i < ilen; i++) {
        if (fileUploadGroup.file_uploads[i].id == id) {
          return fileUploadGroup.file_uploads[i];
        }
      }
    }
  }

  render() {
    var fileUploadGroup = this.state.file_upload_groups && this.state.file_upload_groups.length ? this.state.file_upload_groups[0] : {file_uploads: []};
    return (
      <div className="file-upload-group-builder">

        <div className="panel panel-default" style={this.props.marginBottom ? this.props.marginBottom : {marginBottom: 0, paddingLeft: 0, paddingRight: 0}}>
          <div className="panel-heading">
            <h3 className="panel-title pull-left">{I18n.t('files')} <span className="ss-help help" title={I18n.t('file_helper_text')}></span></h3>
            <div className="clearfix"></div>
          </div>
          <div className="panel-body">
            {this.props.read_only || this.props.file_upload_groups[0].file_uploads.length > 0 && this.props.singleFile ? null : this.renderDropzone()}
            {this.renderFileUploads(fileUploadGroup)}
          </div>
        </div>
      </div>
    );
  }

  renderDropzone() {
    return (
      <div className="dropzone-container" data-dropzone-preview="image" key="dropzone">
        <div className="dropzone-image-spinner" style={{display: this.state.uploading ? 'block' : 'none'}}>
          <div className="progress" style={{width: this.state.progress + '%'}}></div>
          <i className="fa fa-3x fa-spinner fa-spin spinner"></i>
          {this.renderName()}
        </div>

        <div ref="dropzone-input" className="dropzone-input upload btn btn-lg btn-secondary btn-block" data-url="/admin/files/upload" data-name="upload" data-file-name="upload_file_name">
          {I18n.t('click_or_drop_to_upload_file')}
        </div>
      </div>
    )
  }

  renderFileUploads(fileUploadGroup) {
    var self = this;
    var idx = -1;
    var fileUploads = fileUploadGroup.file_uploads.map(function (file_upload) {
      idx = idx + 1;
      return self.renderFileUpload(file_upload, idx);
    });

    if (this.props.read_only === true && (fileUploads == null || fileUploads.length == 0)) {
      return (
        <div className="no-records"><span className="none">{I18n.t('none')}</span></div>
      );
    } else {
      return (
        <div className="sortable-images" ref="images" style={{ display: (fileUploads && fileUploads.length ? 'block' : 'none') }}>{fileUploads}</div>
      );
    }
  }

  renderFileUpload(file_upload, idx) {
    return (
      <div className="sortable-image" data-id={file_upload.id} key={file_upload.id} style={{marginTop: this.props.read_only ? 0 : '15px'}}>
        <table className="fixed">
          <tbody>
            <tr>
              <td><div className="label"><a href={file_upload.original_url} className="open-new-window" target="_blank">{file_upload.upload_file_name}</a></div></td>
              <td className="remove-file-btn-cell">
                <input type="hidden" name="file_upload_id[]" value={file_upload.id} />
                {this.props.read_only ? null : <button type="button" className="pull-right btn btn-secondary btn-sm remove-btn" onClick={this.removeFileUpload.bind(null, file_upload.id)}>{I18n.t('remove')}</button>}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderName() {
    if (this.state.file_name && this.state.progress == 100) {
      return <div className="name">{I18n.t('processing_and_saving')} {this.state.file_name}. {I18n.t('please_wait_ellipsis')}</div>
    } else if (this.state.file_name && this.state.progress != 100) {
      return <div className="name">{I18n.t('Uploading')} {this.state.file_name} {I18n.t('ellipsis')}</div>
    }
  }

  removeFileUpload(id) {
    if (this.state.file_upload_groups && this.state.file_upload_groups.length) {
      var fileUploadGroup = this.state.file_upload_groups[0];
      for (var i = 0, ilen = fileUploadGroup.file_uploads.length; i < ilen; i++) {
        if (fileUploadGroup.file_uploads[i].id == id) {
          fileUploadGroup.file_uploads.splice(i, 1);
          break;
        }
      }
      this.forceUpdate();
      if (typeof this.props.onChange == 'function') {
        this.props.onChange(fileUploadGroup);
      }
    }
  }

}

export default FileUploadGroupBuilder
